var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Frame',{staticClass:"bind",attrs:{"name":_vm.title}},[(_vm.type==1)?_c('BindResult'):_c('BindForm')],1)}
var staticRenderFns = []

export { render, staticRenderFns }